import { AsyncStatus } from "../redux/base.state";
import { PopupData } from "./popup.types";

export interface PopupState {
  data: PopupData | null;
  status: AsyncStatus;
  error: string | null;
}

export const initialPopupState: PopupState = {
  data: null,
  status: "idle",
  error: null,
};